import React, { useRef } from "react";
import { Box, Typography, Container, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import gsap from "gsap";

import NewlyLaunchedCard from "../../cards/newlyAddedCards";

import threeSlotBg from "../../../../../static/Images/newlyAdded/3_slot_game.png";
import fiveSlotBg from "../../../../../static/Images/newlyAdded/5_slot_game.png";
import bgImage from "../../../../../static/Images/newlyAdded/newlyAddedGames_bg.png";

const GAMES = [
  {
    id: "3-slotbet",
    type: "3-slot",
    title: "3-SlotBET",
    category: "SLOTS",
    accent: "red",
    image: threeSlotBg,
    route: "/all-three-slotlottery",
  },
  {
    id: "5-slotbet",
    type: "5-slot",
    title: "5-SlotBET",
    category: "SLOTS",
    accent: "blue",
    image: fiveSlotBg,
    route: "/all-five-slotlottery",
  },
];

const NewlyLaunched = () => {
  const theme = useTheme();
  const history = useHistory();
  const cardRefs = useRef({});

  const handleGameClick = (route) => {
    if (route) {
      history.push(route);
    }
  };

  const handleMouseEnter = (id) => {
    const card = cardRefs.current[id];

    if (!card) return;

    const background = card.querySelector(
      ".newly-launched-card__background"
    );

    gsap.killTweensOf(card);

    gsap.to(card, {
      scale: 1.02,
      duration: 0.3,
      ease: "power2.out",
      overwrite: true,
    });

    if (background) {
      gsap.killTweensOf(background);

      gsap.to(background, {
        scale: 1.05,
        duration: 0.5,
        ease: "power2.out",
        overwrite: true,
      });
    }
  };

  const handleMouseLeave = (id) => {
    const card = cardRefs.current[id];

    if (!card) return;

    const background = card.querySelector(
      ".newly-launched-card__background"
    );

    gsap.killTweensOf(card);

    gsap.to(card, {
      scale: 1,
      duration: 0.3,
      ease: "power2.out",
      overwrite: true,
    });

    if (background) {
      gsap.killTweensOf(background);

      gsap.to(background, {
        scale: 1,
        duration: 0.5,
        ease: "power2.out",
        overwrite: true,
      });
    }
  };

  return (
    <Box
      component="section"
      sx={(theme) => ({
        width: "100%",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        bgcolor: "#f7f9fc",
        pt: {
          xs: theme.custom.layoutSizes.mobileStandard.padding.topBottom,
          sm: theme.custom.layoutSizes.section.paddingTop,
        },
        pb: {
          xs: theme.custom.layoutSizes.mobileStandard.padding.topBottom,
          sm: theme.custom.layoutSizes.section.paddingBottom,
        },
        px: {
          ...theme.custom["home-section-left-padding"],
          xs: theme.custom.layoutSizes.mobileStandard.padding.leftRight,
        },
      })}
    >
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          width: "100%",
          maxWidth: "1400px",
          mx: "auto",
          pt: 0,
          pb: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
          sx={{
            width: "100%",
            mb:
              theme.typography.homeSection?.headerBottomMargin || {
                xs: 4,
                md: 5,
              },
          }}
        >
          <Box
            sx={
              theme.typography.homeSection?.headerContainer || {}
            }
          >
            <Typography
              component="p"
              sx={{
                ...(theme.typography.homeSection?.eyebrow || {}),
                fontSize: {
                  xs: theme.custom.layoutSizes.mobileStandard.typography.eyebrow.fontSize,
                },
                color: "primary.main",
                "&::before": {
                  ...(theme.typography.homeSection?.eyebrow?.[
                    "&::before"
                  ] || {}),
                  background: theme.palette.primary.main,
                },
              }}
            >
              NEW GAMES
            </Typography>

            <Typography
              component="h2"
              sx={{
                ...(theme.typography.homeSection?.heading || {}),
                color:
                  theme.custom?.colors?.home?.navyDark ||
                  "#0d1b36",
              }}
            >
              Newly Launched
            </Typography>
          </Box>
        </Stack>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(2, minmax(0, 1fr))",
            },
            gap: {
              xs: theme.custom.layoutSizes.section.gap.xs,
              sm: "24px",
            },
          }}
        >
          {GAMES.map((game) => (
            <Box
              key={game.id}
              ref={(element) => {
                cardRefs.current[game.id] = element;
              }}
              className="newly-launched-card-wrapper"
              onMouseEnter={() => handleMouseEnter(game.id)}
              onMouseLeave={() => handleMouseLeave(game.id)}
              onClick={() => handleGameClick(game.route)}
              sx={{
                width: "100%",
                height: "100%",
                cursor: "pointer",
                transformOrigin: "center center",
                willChange: "transform",
              }}
            >
              <NewlyLaunchedCard game={game} />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default NewlyLaunched;